import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function checkoutDataFromQuery(query) {
  var _query$get, _query$get2, _query$get3, _query$get4;
  const planId = (_query$get = query.get('planId')) != null ? _query$get : undefined;
  const planSlug = (_query$get2 = query.get('planSlug')) != null ? _query$get2 : undefined;
  const {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    maxStartDate,
    minStartDate,
    biOptions,
    verticalStatusContent
  } = integrationDataFromQuery(query);
  const base = {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    minStartDate,
    maxStartDate,
    biOptions,
    verticalStatusContent,
    memberId: (_query$get3 = query.get('memberId')) != null ? _query$get3 : undefined,
    orderId: (_query$get4 = query.get('orderId')) != null ? _query$get4 : undefined
  };
  if (planId) {
    return {
      ...base,
      planId,
      planSlug: undefined
    };
  } else if (planSlug) {
    return {
      ...base,
      planId: undefined,
      planSlug
    };
  } else {
    throw new MissingRequiredParameterError('planId', 'planSlug');
  }
}
export function checkoutDataToQuery(data) {
  const query = commonIntegrationDataToQuery(data.integrationData);
  query.set('planId', data.planId);
  data.memberId && query.set('memberId', data.memberId);
  data.orderId && query.set('orderId', data.orderId);
  return query;
}
//# sourceMappingURL=checkout-data.js.map